// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2MgM8","logo":"Header_logo__weVT7"};